var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("SimpleTextPopup", {
    attrs: {
      title: _vm.$t("uploadPackageDimensions"),
      rightMethod: _vm.confirmExcelData,
      rightButtonText: _vm.$t("ok"),
      rightButtonDisabled: !_vm.sheetData.length > 0,
      medium: ""
    },
    on: { popupClose: _vm.close },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-btn",
              {
                staticClass: "upload-file",
                attrs: {
                  color: "primary",
                  title: "$t('uploadPackageDimensions')",
                  loading: _vm.loading
                }
              },
              [
                _c("v-icon", { attrs: { dark: "", left: "" } }, [
                  _vm._v("cloud_upload")
                ]),
                _vm._v("\n      " + _vm._s(_vm.$t("upload")) + "\n      "),
                _c("input", {
                  ref: "file",
                  attrs: {
                    type: "file",
                    accept:
                      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  },
                  on: { change: _vm.processFile }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                attrs: { color: "primary", flat: "" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.downloadTemplate.apply(null, arguments)
                  }
                }
              },
              [
                _c(
                  "v-icon",
                  { staticClass: "mx-2", attrs: { dark: "", large: "" } },
                  [_vm._v("cloud_download")]
                ),
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("downloadTemplate")) + "\n    "
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-layout",
              { attrs: { sm12: "", md12: "" } },
              [_c("v-progress-linear")],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "status-area" },
              [
                !_vm.isVerified
                  ? _c(
                      "v-layout",
                      {
                        staticClass: "subheading",
                        attrs: {
                          "align-start": "",
                          "justify-center": "",
                          row: "",
                          "fill-height": ""
                        }
                      },
                      [
                        _c("v-flex", { attrs: { sm1: "" } }, [
                          _vm._v(_vm._s(_vm.$t("result")) + ":")
                        ]),
                        _vm._v(" "),
                        _c("v-flex", { style: _vm.statusColor }, [
                          _vm._v(_vm._s(_vm.result))
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isVerified
                  ? _c("v-data-table", {
                      staticClass: "my-1 levation-2 myDense",
                      attrs: {
                        headers: _vm.headers,
                        items: _vm.sheetData,
                        "hide-actions": ""
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "items",
                            fn: function(props) {
                              return [
                                _c("td", { staticClass: "subheading" }, [
                                  _vm._v(_vm._s(props.index + 1))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(_vm._s(props.item.Quantity))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(_vm._s(props.item.Weight))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(_vm._s(props.item.Length))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(_vm._s(props.item.Width))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(_vm._s(props.item.Height))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(_vm._s(props.item.DeclaredValue))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(_vm._s(props.item.Memo))
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3013838276
                      )
                    })
                  : _vm._e()
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.isShow,
      callback: function($$v) {
        _vm.isShow = $$v
      },
      expression: "isShow"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01c4b462", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01c4b462","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImportPackagesDimensions.vue
// module id = null
// module chunks = 